<template>
  <div class="screen-container panel-components">
    <div class="text-center item-carousel max-w-357 mx-auto">
      <div class="logo-icon">
        <img :src="LogoIcon4" alt="" />
      </div>
      <h3 class="mt-6">Preparing for Calibration…</h3>
      <p>We are now going to present a set of ten candidates.</p>
      <div>
        <v-progress-linear
          color="#4F46E5"
          buffer-value="100"
          :value="progress"
          height="18"
          backgroundColor="#E9E9E9"
          class="mt-12"
        >
          <template v-slot:default="{ value }">
            {{ Math.ceil(value) }}%
          </template>
        </v-progress-linear>
      </div>
    </div>
  </div>
</template>
<script>
import LogoIcon4 from '@/assets/img/presentation-cards-svgrepo-com.svg';

export default {
  name: 'PanelProcessBar',
  props: {
    progress: [String, Number],
  },

  data() {
    return {
      LogoIcon4,
    };
  },
};
</script>
